import { useCallback } from 'react';
import useApiCall from 'hooks/useApiCall';
import { ApiCallFunction } from 'api/models/ApiCallFunction';
import { IApiResponse } from 'api/models/IApiResponse';
import { useAuthContext } from 'hooks/useAuthContext';

const useWorkspaceApiCall = <RequestType, ResponseType>(
  apiCallFunction: ApiCallFunction<RequestType & { workspaceId: string }, IApiResponse<ResponseType>>,
  successMessageKey?: string,
  errorMessageKey?: string
) => {
  const { userState } = useAuthContext();
  const { callAPI, loading } = useApiCall<RequestType & { workspaceId: string }, ResponseType>(
    apiCallFunction,
    successMessageKey,
    errorMessageKey
  );

  const callAPIWithWorkspace = useCallback(
    async (params: RequestType): Promise<IApiResponse<ResponseType> | null> => {
      const workspaceId = userState.user.selectedWorkspace.workspaceId;
      if (!workspaceId) {
        return null;
      }
      return callAPI({ ...params, workspaceId });
    },
    [userState.user.selectedWorkspace.workspaceId]
  );

  return { callAPI: callAPIWithWorkspace, loading };
};

export default useWorkspaceApiCall;
